// SOCIALS **********************************************

export const TELEGRAM = "https://t.me/Finder_AI";
export const TWITTER = "https://x.com/finder_ai_app";

// CONTACT'S ********************************************

export const CONTACT_MAIL = "finderai.app@gmail.com";
